import { useLocale } from 'next-intl';
import { getRequestConfig } from 'next-intl/server';

import { locales } from '@/navigation';

import { allLangs } from './config-lang';

/**
 * @internal default export used by `next-intl` to load locale and messages
 */
export default getRequestConfig(async ({ requestLocale }) => {
  let locale = await requestLocale;

  if (!locale || !locales.includes(locale)) {
    [locale] = locales;
  }

  return {
    locale,
    messages: await import(`./locale/${locale}/index.ts`).then((m) => m.default),
  };
});

type LangConfig = (typeof allLangs)[number];

export const useLocaleConfig = (): { allLangs: typeof allLangs; currentLang: LangConfig } => {
  const locale = useLocale();
  const currentLang = allLangs.find((lang) => lang.value === locale) ?? allLangs[0];

  if (!currentLang) {
    throw new Error(`No language config found for locale "${locale}"`);
  }

  return {
    allLangs,
    currentLang,
  };
};
export const useLocalizedPath = (path: string) => {
  const locale = useLocale();
  return `/${locale}${path}`;
};
